<template>
  <!-- 升级任务组件 -->
  <div>
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      width="60%"
      center
      append-to-body
    >
      <div style="text-align:center">
        <div class="Left_Con">
          <div class="dialog-con">
            <span class="tetxp">{{ $t("lang.taskDialog.FutureTask") }}：</span>
            <el-input
              size="mini"
              class="adduserinput"
              v-model="addtaskname"
              :placeholder="$t('lang.taskDialog.provide')"
            ></el-input>
          </div>
          <div class="dialog-con">
            <span class="tetxp">{{ $t("lang.taskDialog.TaskStatus") }}：</span>
            <el-input
              size="mini"
              v-model="addtaskms"
              :placeholder="$t('lang.taskDialog.TaskStatus')"
              class="adduserinput"
            />
          </div>
          <div class="dialog-con">
            <span class="tetxp">{{ $t("lang.upgrade.file") }}：</span>
            <el-select
              v-model="pack"
              :placeholder="$t('lang.taskDialog.please')"
              class="adduserinput"
              size="mini"
              @change="getpack"
              filterable
              clearable
            >
              <el-option
                v-for="item in GetUpgradeTypeList"
                :key="item.spId"
                :label="item.spName"
                :value="item.spId"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-con">
            <span class="tetxp">{{ $t("lang.taskDialog.fileServer") }}：</span>
            <el-select
              v-model="FirmwareValue"
              :placeholder="$t('lang.taskDialog.please')"
              class="adduserinput"
              size="mini"
            >
              <el-option
                v-for="item in FirmwareList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="Right_Con">
          <div class="dialog-con">
            <span class="tetxp">{{ $t("lang.taskDialog.group1") }}：</span>
            <el-select
              v-model="Grouping1"
              :placeholder="$t('lang.taskDialog.please')"
              class="adduserinput"
              filterable
              size="mini"
              @change="getGroupList2"
              clearable
            >
              <el-option
                v-for="item in Grouplist"
                :key="item.group_id"
                :label="item.group_name"
                :value="item.group_id"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-con">
            <span class="tetxp">{{ $t("lang.taskDialog.group2") }}：</span>
            <el-select
              v-model="Grouping2"
              :placeholder="$t('lang.taskDialog.please')"
              class="adduserinput"
              filterable
              size="mini"
              @change="getGroupList3"
            >
              <el-option
                v-for="item in Groupinglist2"
                :key="item.group_id"
                :label="item.group_name"
                :value="item.group_id"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-con">
            <span class="tetxp">{{ $t("lang.taskDialog.group3") }}：</span>
            <el-select
              v-model="Grouping3"
              :placeholder="$t('lang.taskDialog.please')"
              class="adduserinput"
              filterable
              size="mini"
              @change="getGroupList3devices"
            >
              <el-option
                v-for="item in Groupinglist3"
                :key="item.group_id"
                :label="item.group_name"
                :value="item.group_id"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-con">
            <span class="tetxp">{{ $t("lang.taskDialog.TaskType") }}：</span>
            <el-select
              v-model="UpgradeTypeValue"
              :placeholder="$t('lang.taskDialog.TaskType')"
              class="adduserinput"
              size="mini"
            >
              <el-option
                v-for="item in UpgradeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div>
        <div style="text-align:center" v-if="Object.keys(uppack).length > 0">
          <div class="dialog-con">
            <span class="packTitle"
              >{{ $t("lang.taskDialog.fileType") }}：</span
            >
            <span class="packText" v-if="uppack.spType == 'upgrade'">
              {{ $t("lang.softwarepackage.UpgradePackage") }}
            </span>
            <span class="packText" v-if="uppack.spType == 'patch'">
              {{ $t("lang.softwarepackage.PatchPackage") }}
            </span>
            <span class="packText" v-if="uppack.spType == 'normal'">
              {{ $t("lang.softwarepackage.OrdinaryFile") }}
            </span>
          </div>
          <div class="dialog-con">
            <span class="packTitle"
              >{{ $t("lang.taskDialog.fileSize") }}：</span
            >
            <span class="packText">{{ uppack.spFileSize / 1024 / 1024 }}M</span>
          </div>
          <div class="dialog-con" v-if="uppack.spSha256">
            <span class="packTitle">SHA256：</span>
            <span class="packText">{{ uppack.spSha256 }}</span>
          </div>
          <div class="dialog-con" v-else>
            <span class="packTitle">MD5：</span>
            <span class="packText">{{ uppack.spMd5 }}</span>
          </div>

        </div>
      </div>
      <div class="Bottom_Con">
        <slot></slot>
        <div class="box-con">
          <el-card class="box-card">
            <div class="box-card--tree">
              <p class="box-card--title">
                {{ $t("lang.taskDialog.deviceList") }}
              </p>
              <el-input
                :placeholder="$t('lang.taskDialog.filter')"
                size="mini"
                clearable
                v-model="filterValue"
              ></el-input>
              <el-tree
                node-key="deviceId"
                :props="DeviceProps"
                :data="deviceslist"
                :filter-node-method="filterNode"
                @check="handleCheckChange"
                ref="UpGradeTree"
                show-checkbox
              ></el-tree>
            </div>
          </el-card>
          <el-card class="box-card">
            <div class="box-card--tree" @dblclick="ShowTextarea">
              <p class="box-card--title">
                {{ $t("lang.taskDialog.deviceChecked") }}(<span
                  class="SelectedColor"
                >
                  <!-- 设备选中列表数量 -->
                  {{
                    TextareaValue
                      ? TextareaValue.split(/\n/g).length
                      : deviceDidList.length
                  }} </span
                >)
              </p>
              <div v-show="!Textarea">
                <p v-for="Item in deviceDidList" :key="Item.deviceId">
                  <span class="Device_List">
                    {{ Item.deviceSn }}
                  </span>
                </p>
              </div>
              <div style="display:flex">
                <div
                  style="width:10%;text-align:center;margin-top:2px;"
                  v-show="Textarea"
                >
                  <span
                    v-for="(Item, index) in TextareaVerification"
                    :key="index"
                  >
                    <i
                      :class="[
                        Item.state === 0
                          ? 'icon-Group- Textare_Success'
                          : 'icon-cuowu Textare_Error',
                      ]"
                    ></i>
                  </span>
                </div>
                <textarea
                  v-show="Textarea"
                  class="Textarea"
                  v-model="TextareaValue"
                  @change="GetTextareaValue"
                ></textarea>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="centerDialogVisible = false">{{
          $t("lang.taskDialog.cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click="AddUpdate"
          size="mini"
          :disabled="disabled"
          >{{ $t("lang.taskDialog.Determine") }}</el-button
        >
      </span>
      <el-dialog
        width="60%"
        center
        :title="$t('lang.taskDialog.confirmCreate')"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div>
          <div class="FinalConfirmationDialog">
            <div class="FinalConfirmationDialog_LeftCon">
              <div>
                <p class="FinalConfirmationDialog_LeftCon__Title">升级文件</p>
                <p>
                  {{ $t("lang.taskDialog.fileSize") }}:{{
                    this.uppack.spFileSize / 1024 / 1024
                  }}M
                </p>
                <p>MD5:{{ this.uppack.spMd5 }}</p>
                <p>
                  {{ $t("lang.taskDialog.filename") }}:{{ this.uppack.spName }}
                </p>
                <p v-if="uppack.spType == 'upgrade'">
                  {{ $t("lang.taskDialog.fileType") }}:{{
                    $t("lang.softwarepackage.UpgradePackage")
                  }}
                </p>
                <p v-else-if="uppack.spType == 'patch'">
                  {{ $t("lang.taskDialog.fileType") }}:{{
                    $t("lang.softwarepackage.PatchPackage")
                  }}
                </p>
                <p v-else-if="uppack.spType == 'normal'">
                  {{ $t("lang.taskDialog.fileType") }}:{{
                    $t("lang.softwarepackage.OrdinaryFile")
                  }}
                </p>
              </div>
            </div>
            <div class="FinalConfirmationDialog_RightCon">
              <p class="FinalConfirmationDialog_RightCon__Title">
                {{ $t("lang.taskDialog.toUpgrade") }}
              </p>
              <div style="overflow:scroll;height:200px;">
                <div v-for="(Item, index) in deviceDidList" :key="index">
                  <p>{{ Item.deviceSn }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false" size="mini">{{
            $t("lang.taskDialog.cancel")
          }}</el-button>
          <el-button
            type="primary"
            @click="addLevelUp"
            :disabled="disabled"
            size="mini"
            >{{ $t("lang.taskDialog.Determine") }}</el-button
          >
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
// 任务组件  --接收两个参数，弹框标题 软件包or配置列表
import {
  addLevelUp,
  addConfig,
  findCanLevelUp,
  getAddLevel3Group,
} from "@/api/task";
import { checkLevelDevices } from "@/api/upgrade";
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
    },
    packlist: {
      type: Array,
      default: () => {
        return [];
      },
    },
    radio: {
      type: String,
    },
  },
  data() {
    return {
      centerDialogVisible: false,
      Grouping1: this.defaultGroupId,
      Grouping2: null,
      Grouping3: null,
      Groupinglist2: [],
      Groupinglist3: [],
      addtaskname: "",
      addtaskms: "",
      value: [],
      deviceslist: [],
      pack: null,
      //设备选中集合
      deviceDidList: [],
      deviceDid: [],
      //上传的文件信息
      uppack: {},
      //文件地址选项
      FirmwareList: [
        { value: 0, label: this.$t("lang.upgrade.BackupServer") },
        { value: 1, label: this.$t("lang.upgrade.DefaultServer") },
      ],
      //文件地址选中值
      FirmwareValue: 1,
      // DeviceProps: {
      //   label: "deviceSn",
      //   children: "devices"
      // },
      DeviceProps: {
        label: "label",
        children: "devices",
      },
      defaultProps: {
        label: "deviceSn",
      },
      //按钮不可点击控制
      disabled: false,
      // 设备待选列表搜索
      filterValue: "",
      TextareaValue: "",
      //编辑框切换
      Textarea: false,
      //创建任务最终确认框
      innerVisible: false,
      //文本域验证
      TextareaVerification: [],
      //文本域节流
      TextareaValueWacth: null,
      //任务类型列表
      UpgradeTypeList: [
        { label: this.$t("lang.upgrade.UpgradeTask"), value: "upgrade" },
        { label: this.$t("lang.upgrade.PatchTask"), value: "patch" },
      ],
      //任务类型选中值
      UpgradeTypeValue: "upgrade",
      //一级分组列表
      Grouplist: [],
    };
  },
  methods: {
    //显示弹出层
    showDialog() {
      this.centerDialogVisible = true;
      //释放确定按钮
      this.disabled = false;
      // 清空所有选择数据
      this.uppack = {};
      this.pack = null;
      this.addtaskname = "";
      this.addtaskms = "";
      this.value = [];
      this.Grouping1 = this.defaultGroupId;
      this.Grouping2 = null;
      this.Grouping3 = null;
      this.deviceDid = [];
      this.deviceDidList = [];
      this.Groupinglist2 = [];
      this.Groupinglist3 = [];
      this.Grouping2 = null;
      this.Grouping3 = null;
      this.TextareaValue = "";
      this.Textarea = false;
      this.UpgradeTypeValue = "upgrade";
      this.deviceslist = [];
      //每次初始化时获取到默认分组下的设备
      this.FindCanLevelUp(this.defaultGroupId);
      setTimeout(() => {
        getAddLevel3Group(0).then((res) => {
          this.Grouplist = res.data.queryResult;
        });
        //一级分组默认选中，获取二级分组
        getAddLevel3Group(this.defaultGroupId).then((res) => {
          console.log(res.data.queryResult);
          this.Groupinglist2 = res.data.queryResult;
        });
      }, 500);
    },
    //获取二级分组
    getGroupList2(val) {
      //每次选择一级分组清空二三级分组已经设备列表
      this.Groupinglist2 = [];
      this.Groupinglist3 = [];
      this.Grouping2 = null;
      this.Grouping3 = null;
      getAddLevel3Group(val).then((res) => {
        this.Groupinglist2 = res.data.queryResult;
      });
      this.FindCanLevelUp(val);
    },
    //获取三级分组
    getGroupList3(val) {
      //每次选择二级级分组清空三级分组已经设备列表
      this.Groupinglist3 = [];
      this.Grouping3 = null;
      getAddLevel3Group(val).then((res) => {
        this.Groupinglist3 = res.data.queryResult;
      });
      this.FindCanLevelUp(val);
    },
    //获取三级分组下的设备
    getGroupList3devices(val) {
      this.FindCanLevelUp(val);
    },
    //获取当前选中的软件包文件
    getpack() {
      this.GetUpgradeTypeList.forEach((val, index, arr) => {
        if (val.spId == this.pack) {
          this.uppack = val;
        }
      });
    },
    //添加升级任务
    addLevelUp() {
      console.log();
      if (this.deviceDidList.length == 0) {
        this.$message({
          showClose: true,
          message: this.$t("lang.taskDialog.please"),
          type: "warning",
        });
        return;
      } else {
        this.deviceDidList.forEach((val, index) => {
          //获取选中的设备
          this.deviceDid.push(val.deviceDid);
        });
      }
      // 文件未选择
      if (this.pack == null) {
        this.$message({
          showClose: true,
          message: this.$t("lang.taskDialog.File_Upload_Upgrader"),
          type: "warning",
        });
        return;
      }
      //点击后确定按钮不可点击
      this.disabled = true;
      // 批量升级任务
      addLevelUp(
        this.addtaskname,
        this.addtaskms,
        this.deviceDid,
        this.uppack.spPath,
        this.uppack.spFileSize,
        this.uppack.spId,
        this.radio,
        this.FirmwareValue,
        this.UpgradeTypeValue
      ).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.taskDialog.Dispatched"),
            type: "success",
          });
          //添加完触发方法刷新列表
          this.$emit("getupgradelist");
          this.centerDialogVisible = !this.centerDialogVisible;
          this.innerVisible = !this.innerVisible;
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.taskDialog.operation"),
            type: "warning",
          });
          //释放确定按钮
          this.disabled = false;
        }
      });
    },
    //获取分组下的设备集合
    FindCanLevelUp(GroupId) {
      //分组id不等于null时获取分组下的设备版本列表
      if (GroupId !== null) {
        findCanLevelUp(GroupId).then((res) => {
          this.deviceslist = res.data.data.map((val, index) => {
            val.deviceSn = val.deviceSoftwareVer;
            this.$set(val, "label", val.deviceSn);
            val.devices.forEach((item, index) => {
              this.$set(
                item,
                "label",
                item.deviceSn +
                  ` (${item.deviceName ? item.deviceName : "N/A"})`
              );
            });
            return val;
          });
          console.log("fenzu");
          console.log(this.deviceslist);
        });
      }
    },
    //tree复选框选中事件
    handleCheckChange() {
      //获取选中的设备
      this.deviceDidList = this.$refs.UpGradeTree.getCheckedNodes(true)
      // this.deviceDidList.find(i=>i.deviceId==)
    },
    //设备待选列表搜索
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value.trim()) !== -1;
      // return data.deviceSn.indexOf(value) !== -1;
    },
    //获取文本域内容
    GetTextareaValue(value) {
      let group = "";
      if (this.Grouping3) {
        group = this.Grouping3;
      } else if (this.Grouping2) {
        group = this.Grouping2;
      } else if (this.Grouping1) {
        group = this.Grouping1;
      }
      checkLevelDevices(group, value.split(/\n/g)).then((res) => {
        this.TextareaVerification = res.data.data;
      });
    },
    //设备选中列表双击事件
    ShowTextarea() {
      if (!this.Textarea) {
        //双击选中列表时，如果选中有值，将选中的值赋值给文本域
        if (this.deviceDidList.length > 0) {
          // 清空文本域值
          this.TextareaValue = "";
          this.deviceDidList.forEach((val, index) => {
            // 将选中列表序列号添加至文本域值中并且添加换行符，如果是最后一个序列号，不添加换行符
            this.TextareaValue += `${val.deviceSn}${
              this.deviceDidList.length - 1 === index ? "" : "\n"
            }`;
          });
          //清空当前选中的设备
          this.deviceDidList = [];
        }
      } else {
        // 如果当前序列号有错误的，结束操作
        if (
          this.TextareaVerification.find((ele) => {
            console.log(ele);
            return ele.state === 1;
          }) !== undefined
        ) {
          this.$message({
            message: this.$t("lang.upgrade.checkSerialNumber"),
            type: "warning",
          });
          return;
        }
        //将文本域中选中值正确的值转换成列表
        this.deviceDidList = this.TextareaVerification;
        // 清空文本域中的值
        this.TextareaValue = "";
      }
      this.Textarea = !this.Textarea;
    },
    //添加升级任务点击确定时的操作
    AddUpdate() {
      // 文件未选择
      if (this.pack == null) {
        this.$message({
          showClose: true,
          message: this.$t("lang.taskDialog.File_Upload_Upgrader"),
          type: "warning",
        });
        return;
      }
      if (this.Textarea) {
        if (
          this.TextareaVerification.find((ele) => {
            return ele.state === 1;
          }) !== undefined
        ) {
          this.$message({
            message: this.$t("lang.upgrade.checkSerialNumber"),
            type: "warning",
          });
          return;
        }
      } else {
        if (this.deviceDidList.length < 0) {
          this.$message({
            message: this.$t("lang.upgrade.selectDevice"),
            type: "warning",
          });
          return;
        }
      }
      if (this.Textarea) {
        this.deviceDidList = this.TextareaVerification;
      }
      if (this.deviceDidList.length == 0) {
        this.$message({
          showClose: true,
          message: this.$t("lang.taskDialog.please"),
          type: "warning",
        });
        return;
      }
      //显示最终确认框
      this.innerVisible = true;
    },
  },
  watch: {
    //设备待选列表搜索
    filterValue(val) {
      this.$refs.UpGradeTree.filter(val);
    },
    //设备选中列表文本域输入监听
    TextareaValue(NewValue, OldValue) {
      // 文本域输入节流
      if (this.TextareaValueWacth !== null) {
        clearTimeout(this.TextareaValueWacth);
      }
      this.TextareaValueWacth = setTimeout(() => {
        this.GetTextareaValue(NewValue);
      }, 300);
    },
  },
  mounted() {
    //加载时获取到默认分组下的设备
    this.FindCanLevelUp(this.defaultGroupId);
    getAddLevel3Group(0).then((res) => {
      this.Grouplist = res.data.queryResult;
    });
    //一级分组默认选中，获取二级分组
    getAddLevel3Group(this.defaultGroupId).then((res) => {
      this.Groupinglist2 = res.data.queryResult;
    });
    this.deviceslist = [];
  },
  computed: {
    ...mapGetters(["defaultGroupId"]),
    // 筛选补丁包与升级包
    GetUpgradeTypeList() {
      let Arr = [];
      this.uppack = {};
      this.pack = null;
      //兼容type为升级包 And upgrade
      this.packlist.map((val) => {
        if (this.UpgradeTypeValue == "upgrade") {
          if (val.spType == "upgrade" || val.spType == "升级包") {
            Arr.push(val);
          }
        } else if (this.UpgradeTypeValue == "patch") {
          if (val.spType == "patch") {
            Arr.push(val);
          }
        }
      });
      return Arr;
    },
  },
};
</script>
<style scoped>
.dialog-con {
  width: 100%;
}
.dialog-con-center {
  text-align: center;
}
.adduserinput {
  display: inline-block;
  width: 40%;
  margin: 0.2rem;
}
.tetxp {
  display: inline-block;
  width: 2.5rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.packTitle {
  display: inline-block;
  margin-top: 0.1rem;
  font-size: 14px;
  color: #888888;
  margin-bottom: 0.1rem;
}
.packText {
  color: #888888;
  font-size: 14px;
}
.box-con {
  margin: 10px 0px;
  display: flex;
  justify-content: center;
}
.box-card {
  width: 48%;
  height: 30vh;
  overflow: scroll;
}
.box-card--tree {
  width: 100%;
}
.box-card--title {
  margin: 0.15rem;
  text-align: center;
  font-size: 15px;
  color: #888888;
}
.Bottom_Con {
  width: 90%;
  border: 1px solid #ebebeb;
  margin: 0 auto;
}
.Left_Con {
  width: 45%;
  margin-bottom: 10px;
  display: inline-block;
  border: 1px solid #ebebeb;
}
.Right_Con {
  width: 45%;
  margin-bottom: 10px;
  display: inline-block;
  border: 1px solid #ebebeb;
}
.Device_List {
  color: #606266;
  font-size: 14px;
  margin-left: 20px;
  line-height: 1.4;
}
.SelectedColor {
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
}
.Textarea {
  border: 1px solid #d7dae2;
  width: 90%;
  padding-left: 10px;
  color: #606266;
}
.Textare_Success {
  width: 20px;
  height: 20px;
  font-size: 14px;
  border-radius: 50%;
  line-height: 1.5;
  text-align: center;
  color: #52c41a;
  display: block;
  margin: 0 auto 1px auto;
}
.Textare_Error {
  width: 20px;
  height: 20px;
  font-size: 15px;
  border-radius: 50%;
  line-height: 1.5;
  text-align: center;
  color: #f5222d;
  display: block;
  margin: 0 auto 1px auto;
}
.FinalConfirmationDialog {
  width: 100%;
  border: 1px solid #ebebeb;
  padding: 5px;
  height: 300px;
  display: flex;
  justify-content: center;
}
.FinalConfirmationDialog_LeftCon {
  height: 280px;
  width: 50%;
  text-align: center;
  color: #888888;
  overflow: hidden;
  display: flex;
  justify-content: center;
  border: 1px solid #ebebeb;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.FinalConfirmationDialog_LeftCon__Title {
  font-size: 22px;
  color: #333;
  margin: 10px 0px;
}
.FinalConfirmationDialog_LeftCon p {
  margin: 5px;
}
.FinalConfirmationDialog_RightCon {
  width: 50%;
  height: 280px;
  padding: 10px 0px;
  color: #888888;
  border: 1px solid #ebebeb;
  text-align: center;
}
.FinalConfirmationDialog_RightCon__Title {
  font-size: 22px;
  color: #333;
  margin: 10px 0px;
}
</style>
